import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Icon from '../../Icon/Icon';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import styles from './BuySubscriptionSuccessDialog.module.scss';

const T_PREFIX = 'subscriptionsScreen.dialogs.buySuccess';

const BuySubscriptionSuccessDialog = (props) => {
    const {
        isVisible,
        onClose,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);

    const confirmButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
            dialogClassName={styles.dialogClassName}
            contentClassName={styles.contentClassName}
        >
            <Modal.Header closeButton>
                <h4 className={styles.dialogTitle}>
                    {t(`${T_PREFIX}.header.title`)}
                </h4>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <div className={styles.contentContainer}>
                    <Icon
                        name="check"
                        size={67}
                        color={tintColor}
                    />
                    <span className={styles.contentTitle}>
                        {t(`${T_PREFIX}.body.title`)}
                    </span>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.dialogFooter}>
                <Button
                    style={confirmButtonStyle}
                    className={styles.confirmButton}
                    onClick={onClose}
                >
                    {t(`${T_PREFIX}.body.actions.confirm`)}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

BuySubscriptionSuccessDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
};

BuySubscriptionSuccessDialog.defaultProps = {
    isVisible: false,
    onClose: emptyFunc,
};

export default BuySubscriptionSuccessDialog;
